import { PANEL } from "./theme";

/** "Loading <map>…" while a map file loads. */
export function LoadingBadge({ name }: { name: string }) {
  return (
    <div
      role="status"
      className={`${PANEL} pointer-events-none absolute left-1/2 top-1/3 -translate-x-1/2 rounded-full px-5 py-2 text-lg font-black uppercase italic`}
    >
      Loading {name}…
    </div>
  );
}
